module.exports = __webpack_public_path__ + "static/media/Piercing-femintimate-Labiamajora.b75651eb.png";